import {Paper, Table, TableBody, TableCell, TableHead, TableRow} from '@material-ui/core';
import {StatusChip, StatusPrintedChip} from '../../component/status-chip';
import {useStyles} from './styles';
import {SaveResultsAction} from '../../component/save-results-action';
import {PrintTest} from '../../component/print-test';
import {NewAttempt} from './new-attempt';
import {AnswerKeyAction} from "../../component/answer-key-action";
import {RightAnswersAction} from "../../component/right-answers-action";

const { format: formatDate } = new Intl.DateTimeFormat('pt-BR', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', });

const calcPercentage = (value, total) => {
  return (value * 100 / total).toFixed(1)
}

export function AssessmentResultsListComponent({ studentResults, onSubmitted, assessmentType }) {
  const classes = useStyles();
  const isPrinted = assessmentType === 'printed';

  return (
    <Paper elevation={1} className={classes.tablePaper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell className={classes.headerCell}>Aluno</TableCell>
            <TableCell className={classes.headerCell}>Status</TableCell>
            {!isPrinted && <TableCell className={classes.headerCell}>Início da Avaliação</TableCell>}
            {!isPrinted && <TableCell className={classes.headerCell}>Término da Avaliação</TableCell>}
            <TableCell className={classes.headerCell}>Acertos</TableCell>
            <TableCell className={classes.headerCell}>% Acertos</TableCell>
            <TableCell className={classes.headerCell}>Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {studentResults.map((student) => (
            <TableRow key={student.id} hover>
              <TableCell className={classes.bodyCell}>
                {student.studentName}
              </TableCell>
              <TableCell className={classes.bodyCell}>
                {
                  isPrinted ? (
                      <StatusPrintedChip status={student.status} />
                  ) : (
                      <StatusChip status={student.status} />
                  )
                }

              </TableCell>
              {!isPrinted && (
                <TableCell className={classes.bodyCell}>
                  {student.startedAt ? formatDate(new Date(student.startedAt)) : '-'}
                </TableCell>
              )}
              {!isPrinted && (
                <TableCell className={classes.bodyCell}>
                  {student.finishedAt ? formatDate(new Date(student.finishedAt)) : '-'}
                </TableCell>
              )}
              <TableCell className={classes.bodyCell}>
                {student.correctAnswers !== null ? `${student.correctAnswers} / ${student.totalQuestions}` : '-'}
              </TableCell>
              <TableCell className={classes.bodyCell}>
                {student.correctAnswers ? calcPercentage(student.correctAnswers, student.totalQuestions) + '%' : null}
              </TableCell>
              <TableCell className={classes.bodyCell} align={'right'}>
                <div style={{display: 'flex', gap: 10}}>
                  {!isPrinted && (
                      <NewAttempt status={student.status} onSubmitted={onSubmitted} id={student.testId} />
                  )}
                  {isPrinted && (
                      <>
                        <PrintTest
                            availabilityId={student.availabilityId}
                            userContextId={student.userContextId}
                            studentName={student.studentName}
                            testId={student.testId}
                            documentStatus={student.documentStatus}
                        />
                        <SaveResultsAction {...student} onSubmitted={onSubmitted} />
                        <AnswerKeyAction {...student} onSubmitted={onSubmitted} />
                      </>
                  )}
                  <RightAnswersAction testId={student.testId} studentName={student.studentName} />
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}
